const getServerConfig = (s: string): { url: string; logo: string } => {
	let response = { url: '', logo: '' }
	const environment: string = process.env.REACT_APP_EDGE_MODE || 'STAGING'

	if (environment === 'STAGING') {
		return {
			url: 'https://superman.dashcx.com/',
			// url: 'http://localhost:8080/',
			logo:
				"https://whatcx.sgp1.cdn.digitaloceanspaces.com/static-media/brand-logo/dash_email_logo.png'",
		}
	}

	switch (s) {
		case 'DASH_CX':
			response = {
				url: 'https://api-v2.edgecx.com/',
				logo:
					'https://whatcx.sgp1.cdn.digitaloceanspaces.com/static-media/brand-logo/dash_email_logo.png',
			}
			break
		case 'TURBO_CX':
			response = {
				url: 'https://api.turbocx.com/',
				logo:
					'https://whatcx.sgp1.cdn.digitaloceanspaces.com/static-media/brand-logo/trubo_cx_light_bg.png',
			}
			break
		default:
			response = {
				url: 'https://api-v2.edgecx.com/',
				logo:
					'https://whatcx.sgp1.cdn.digitaloceanspaces.com/static-media/brand-logo/dash_email_logo.png',
			}
			break
	}
	return { ...response }
}

export default getServerConfig
